document.addEventListener("DOMContentLoaded", function () {
  console.log('DOM加载完成，开始初始化轮播');
  const carousels = document.querySelectorAll(".joe-nav-product_wrapper");
  console.log('找到轮播容器数量:', carousels.length);

  // 直接初始化所有轮播，不使用 Intersection Observer
  carousels.forEach((carousel) => {
    initCarousel(carousel);
  });

  function initCarousel(carousel) {
    const sectionId = carousel.getAttribute("data-section-id");
    const autoPlayEnabled = carousel.getAttribute("data-autoplay") !== "false"; // 默认启用自动播放，除非明确设为false
    const itemsContainer = carousel.querySelector(".joe-nav-product_items");
    const items = carousel.querySelectorAll(".joe-nav-product_item");
    
    // 图片轮播相关元素
    const imagesContainer = carousel.querySelector(".joe-nav-product_images");
    const images = carousel.querySelectorAll(".joe-nav-product_image");
    const imageDots = carousel.querySelectorAll(".nav-product_images-dot");
    
    // 安全检查
    if (!itemsContainer || items.length === 0) {
      console.log('轮播初始化失败：缺少必要元素');
      return;
    }

    console.log('初始化轮播组件:', { 
      sectionId, 
      autoPlayEnabled, 
      itemsCount: items.length,
      dataAutoplay: carousel.getAttribute("data-autoplay")
    });
    
    // 测试项目是否正确获取
    items.forEach((item, index) => {
      console.log(`项目 ${index}:`, item, 'offsetLeft:', item.offsetLeft);
    });

    // 简化的轮播变量
    let currentIndex = 0;
    let autoplayInterval = null;
    const autoplayDelay = 5000; // 3秒轮播一次
    let isPaused = false;
    
    // 获取导航相关元素
    const navBarContainer = carousel.querySelector(".joe-nav-product_nav-container");
    const navTitles = navBarContainer?.querySelectorAll("div.joe-nav-product_nav");
    const navBar = navBarContainer?.querySelector(".joe-nav-product_nav-bar");
    const bottomNavContainer = carousel.querySelector(".joe-nav-product_bottom-nav");
    const bottomNavBar = bottomNavContainer?.querySelector(".joe-nav-product_bottom-nav-bar");

    // 核心轮播函数
    function goToSlide(index) {
      if (index < 0 || index >= items.length) return;
      
      currentIndex = index;
      console.log('切换到幻灯片:', currentIndex, '项目总数:', items.length);
      
      // 计算滚动位置：使用项目的 offsetLeft 属性
      const targetItem = items[currentIndex];
      const scrollLeft = targetItem.offsetLeft;
      
      console.log('滚动到位置:', scrollLeft, '目标元素 offsetLeft:', targetItem.offsetLeft);
      
      itemsContainer.scrollTo({
        left: scrollLeft,
        behavior: "smooth"
      });
      
      // 同步图片轮播
      if (imagesContainer && images[currentIndex]) {
        const targetImage = images[currentIndex];
        const imgScrollLeft = targetImage.offsetLeft;
        
        imagesContainer.scrollTo({
          left: imgScrollLeft,
          behavior: "smooth"
        });
      }
      
      // 更新导航点
      updateImageDots(currentIndex);
      updateNavigation(currentIndex);
      
      // 延迟更新底部导航条，等滚动完成
      setTimeout(() => {
        updateBottomNavBar();
      }, 300);
    }
    
    function nextSlide() {
      const nextIndex = (currentIndex + 1) % items.length;
      console.log('下一张：从', currentIndex, '到', nextIndex, '总数:', items.length);
      
      if (nextIndex === currentIndex) {
        console.log('警告：下一个索引与当前索引相同');
      }
      
      goToSlide(nextIndex);
    }
    
    function prevSlide() {
      const prevIndex = (currentIndex - 1 + items.length) % items.length;
      goToSlide(prevIndex);
    }
    
    // 自动播放函数
    function startAutoplay() {
      if (!autoPlayEnabled) {
        console.log('自动播放未启用');
        return;
      }
      
      if (autoplayInterval) {
        console.log('自动播放已在运行');
        return;
      }
      
      console.log('开始自动播放，当前索引:', currentIndex);
      autoplayInterval = setInterval(() => {
        if (!isPaused && !document.hidden) {
          console.log('自动播放执行，当前状态:', { isPaused, hidden: document.hidden, currentIndex });
          nextSlide();
        } else {
          console.log('自动播放跳过，原因:', { isPaused, hidden: document.hidden });
        }
      }, autoplayDelay);
    }
    
    function stopAutoplay() {
      if (autoplayInterval) {
        console.log('停止自动播放');
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }
    
    function pauseAutoplay() {
      console.log('暂停自动播放');
      isPaused = true;
      setTimeout(() => {
        console.log('恢复自动播放');
        isPaused = false;
      }, 1000); // 缩短到1秒后恢复
    }

    // 事件监听器
    // 导航点击事件
    if (navTitles) {
      navTitles.forEach((navTitle, index) => {
        navTitle.addEventListener("click", () => {
          pauseAutoplay();
          goToSlide(index);
        });
      });
    }
    
    // 图片点击事件
    if (images.length > 0) {
      images.forEach((image, index) => {
        image.addEventListener("click", () => {
          pauseAutoplay();
          goToSlide(index);
        });
      });
    }
    
    // 导航点点击事件
    if (imageDots.length > 0) {
      imageDots.forEach((dot, index) => {
        dot.addEventListener("click", () => {
          pauseAutoplay();
          goToSlide(index);
        });
      });
    }
    
    // 鼠标悬停暂停 - 只在真正交互时暂停
    carousel.addEventListener("mouseenter", () => {
      console.log('鼠标进入，暂停轮播');
      isPaused = true;
    });
    
    carousel.addEventListener("mouseleave", () => {
      console.log('鼠标离开，恢复轮播');
      isPaused = false;
    });

    // 页面可见性变化处理
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        stopAutoplay();
      } else if (autoPlayEnabled) {
        startAutoplay();
      }
    });

    // 辅助函数
    function updateImageDots(activeIndex) {
      if (!imageDots || imageDots.length === 0) return;
      
      imageDots.forEach((dot, index) => {
        const dotNav = dot.querySelector('.nav-product_images-dot_nav');
        if (dotNav) {
          if (index === activeIndex) {
            dot.classList.add("dot_nav-active");
            dotNav.style.width = '100%';
            dotNav.style.height = '3px';
          } else {
            dot.classList.remove("dot_nav-active");
            dotNav.style.width = '';
            dotNav.style.height = '';
          }
        }
      });
    }

    function updateBottomNavBar() {
      if (!bottomNavBar || !itemsContainer) return;
      
      const totalScrollWidth = itemsContainer.scrollWidth;
      const viewportWidth = itemsContainer.clientWidth;
      const navBarWidthRatio = viewportWidth / totalScrollWidth;
      const containerWidth = bottomNavContainer.clientWidth;
      const navBarWidth = Math.max(30, navBarWidthRatio * containerWidth);
      const maxScroll = totalScrollWidth - viewportWidth;
      const currentScrollRatio = maxScroll > 0 ? itemsContainer.scrollLeft / maxScroll : 0;
      const maxNavBarOffset = containerWidth - navBarWidth;
      const navBarLeft = currentScrollRatio * maxNavBarOffset;
      
      bottomNavBar.style.width = `${navBarWidth}px`;
      bottomNavBar.style.left = `${navBarLeft}px`;
    }
    
    function updateNavigation(index) {
      if (!navTitles || !navTitles[index] || !navBar) return;
      
      navTitles.forEach((nav) => nav.classList.remove("largvideo_nav-active"));
      navTitles[index]?.classList.add("largvideo_nav-active");
      
      const navMoveTo = navTitles[index];
      const containerRect = navBarContainer.getBoundingClientRect();
      const itemRect = navMoveTo.getBoundingClientRect();
      
      const navMoveTostyle = window.getComputedStyle(navMoveTo);
      const navMoveTototalWidth = parseFloat(navMoveTostyle.width);
      const navMoveTopaddingLeft = parseFloat(navMoveTostyle.paddingLeft);
      const navMoveTopaddingRight = parseFloat(navMoveTostyle.paddingRight);
      const navBarWidth = navMoveTototalWidth - navMoveTopaddingLeft - navMoveTopaddingRight;
      navBar.style.width = `${navBarWidth}px`;
      
      const scrollOffset = navBarContainer.scrollLeft;
      const relativeLeft = (itemRect.left - containerRect.left) + scrollOffset;
      navBar.style.left = `${relativeLeft}px`;
      
      if (navBarContainer.scrollWidth > navBarContainer.clientWidth) {
        const scrollLeft = relativeLeft - (navBarContainer.clientWidth - navBarWidth) / 2;
        navBarContainer.scrollTo({
          left: scrollLeft,
          behavior: "smooth",
        });
      }
    }

    // 初始化
    console.log('初始化轮播，项目数量:', items.length);
    goToSlide(0); // 初始化第一张
    
    // 启动自动轮播
    if (autoPlayEnabled) {
      console.log('准备启动轮播，间隔:', autoplayDelay + 'ms');
      
      // 立即启动
      console.log('立即启动轮播');
      startAutoplay();
      
      // 立即测试一次轮播
      setTimeout(() => {
        console.log('立即测试轮播功能');
        isPaused = false; // 强制取消暂停
        nextSlide();
      }, 500);
      
      // 强制检查机制
      setInterval(() => {
        if (autoPlayEnabled && !autoplayInterval && !document.hidden) {
          console.log('强制重启轮播，当前索引:', currentIndex);
          startAutoplay();
        }
        
        // 强制重置暂停状态 - 如果轮播被意外暂停太久
        if (isPaused && autoPlayEnabled) {
          console.log('检测到长时间暂停，强制恢复');
          isPaused = false;
        }
      }, 3000); // 缩短到3秒检查
    } else {
      console.log('自动播放未启用，当前设置:', carousel.getAttribute("data-autoplay"));
    }
    
    // 添加全局测试函数
    window.testCarousel = {
      next: nextSlide,
      prev: prevSlide,
      goto: goToSlide,
      start: startAutoplay,
      stop: stopAutoplay,
      getCurrentIndex: () => currentIndex,
      getItemsCount: () => items.length,
      forceResume: () => {
        console.log('强制恢复轮播');
        isPaused = false;
        if (!autoplayInterval) {
          startAutoplay();
        }
      },
      getStatus: () => ({
        currentIndex,
        isPaused,
        hasInterval: !!autoplayInterval,
        autoPlayEnabled,
        itemsLength: items.length
      })
    };
  }
});